import http from '@/utils/http';

export const ProtocolosService = {
    buscarProtocolos(filtro, apenasAtivo = true) {
        return http.get({
            url: `/protocolo/protocolos?apenasAtivo=${apenasAtivo}`,
            data: filtro,
            lockScreen: false
        });
    },
    buscarTotalProtocolosVinculados() {
        return http.get({
            url: `/protocolo/protocolos/total`,
            lockScreen: false
        });
    },
    buscarQtdProtocolosPorEmpresa(filtro, { pagina, tamanho }) {
        return http.post({
            url: `/protocolo/buscar/empresas?page=${pagina - 1}&size=${tamanho}`,
            data: filtro,
            lockScreen: false
        });
    },
    buscarProtocolosPorEmpresa(idEmpresa) {
        return http.get({
            url: `/protocolo/buscar/empresas/${idEmpresa}`,
            lockScreen: false
        });
    },
    buscarProtocolosPorUsuario() {
        return http.get({
            url: `/protocolo/buscar/protocolos-vinculados`,
            lockScreen: false
        }).then(response => {
            return response.data.map(item => {
                    return {
                        ...item,
                        nome: item.codigo
                            .split('_')
                            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                            .join(' ')
                    };
            });
        });
    },
    vincularProtocoloEmpresa(bodyData) {
        return http.post({
            url: `/protocolo/vincular-protocolos`,
            data: bodyData,
            lockScreen: false
        });
    },
    buscarCamadasProtocolo(nomeProtocolo) {
        return http.get({
            url: `/protocolo/${nomeProtocolo}/camadas`,
            lockScreen: false
        });
    }
};
